import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { UserService } from 'src/app/services/shared/user.service';
import { TerraUtils } from 'src/app/shared/TerraUtils';
import { LpUiService } from '../shared/lp-ui.service';
import { RoutingService } from 'src/app/services/routing.service';
import { InvestingEntityShareService } from '../investing-entity-share/services/investing-entity-share.service';
import { shareReplay } from 'rxjs';

@Component({
  selector: 'terra-lp-profile',
  templateUrl: './lp-profile.component.html',
  styleUrls: ['./lp-profile.component.scss'],
})
export class LpProfileComponent implements OnInit {
  constructor(
    public routingService: RoutingService,
    private userService: UserService,
    private lpUiService: LpUiService,
    private titleService: Title,
    private readonly investingEntityShareService: InvestingEntityShareService
  ) {
    this.lpUiService.showMainNav();
  }

  get isMobileDevice(): boolean {
    return TerraUtils.isMobileDevice();
  }

  logoutPath = TerraUtils.consts.paths.LOGOUT;
  accountDetails$ = this.userService.accountDetails$;
  supportPin$ = this.userService.supportPin$;
  availableInvestingEntities$ = this.investingEntityShareService.investingEntities$.pipe(
    shareReplay(1)
  );

  ngOnInit() {
    this.titleService.setTitle(
      'Settings and My Profile' + TerraUtils.consts.LpPageTitleSuffix
    );
  }

  share() {
    this.investingEntityShareService.openModal();
  }

}
